import React from "react";
import logo from "./logo.png";

export default function LandingPage() {
  const phone = "0546653527";

  const whatsappLink = `https://wa.me/972${phone.substring(
    1
  )}?text=${encodeURIComponent("היי מוטי, הגעתי מהאתר ואשמח לעזרה")}`;

  return (
    <div className="font-sans max-w-5xl mx-auto bg-white" dir="rtl">
      {/* HEADER */}
      <div className="sticky top-0 bg-white z-50 shadow-sm py-4 px-5 border-b border-gray-100">
        <div className="flex flex-col md:flex-row gap-3 justify-center items-center">
          <a
            href={`tel:${phone}`}
            className="bg-[#005B8E] hover:bg-[#0B3C66] text-white text-lg md:text-xl py-3 px-6 rounded-full shadow-md font-bold transition"
          >
            התקשר עכשיו
          </a>

          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#00B6C4] hover:bg-[#0097a7] text-white text-lg md:text-xl py-3 px-6 rounded-full shadow-md font-bold transition"
          >
            שלח הודעה בוואטסאפ
          </a>
        </div>
      </div>

      <div className="px-5 py-10">
        {/* LOGO */}
        <div className="text-center mb-6">
          <img
            src={logo}
            alt="מוטי שוקרון - שירותי אינסטלציה"
            className="mx-auto w-3/4 max-w-md mb-2"
          />
        </div>

        {/* HERO */}
        <div className="text-center mb-10">
          <p className="text-lg md:text-2xl text-[#005B8E] font-semibold mb-4">
            אינסטלטור אמין וזמין בשומרון, ראש העין ופתח תקווה
          </p>

          <h1 className="text-3xl md:text-5xl text-[#0B3C66] font-bold leading-tight mb-6">
            סתימה, נזילה או תקלה בדוד?
            <br />
            מוטי שוקרון מגיע לטפל בזה כמו שצריך.
          </h1>

          <p className="text-lg md:text-2xl text-gray-700 leading-relaxed max-w-3xl mx-auto">
            שירות אישי, מקצועי ונקי, עם ניסיון רב בתחום, יחס בגובה העיניים ומחיר
            ברור לפני תחילת העבודה.
          </p>
        </div>

        {/* TRUST */}
        <div className="bg-[#F5FBFC] border border-[#D8EEF2] rounded-xl p-6 mb-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 text-center">
            <div>
              <h3 className="text-xl md:text-2xl font-bold text-[#0B3C66] mb-2">
                ניסיון בשטח
              </h3>
              <p className="text-gray-700 text-base md:text-lg">
                טיפול במגוון תקלות אינסטלציה בבתים, עסקים ומבנים.
              </p>
            </div>

            <div>
              <h3 className="text-xl md:text-2xl font-bold text-[#0B3C66] mb-2">
                הגעה מהירה
              </h3>
              <p className="text-gray-700 text-base md:text-lg">
                מבין שתקלה במים לא יכולה לחכות ומגיע בזמן האפשרי.
              </p>
            </div>

            <div>
              <h3 className="text-xl md:text-2xl font-bold text-[#0B3C66] mb-2">
                בלי הפתעות
              </h3>
              <p className="text-gray-700 text-base md:text-lg">
                מסביר את הבעיה, נותן מחיר ברור ועובד בשקיפות.
              </p>
            </div>
          </div>
        </div>

        {/* SERVICES */}
        <div className="mb-12">
          <h2 className="text-2xl md:text-4xl text-center text-[#00B6C4] mb-6 font-semibold">
            שירותי אינסטלציה
          </h2>

          <ul className="text-lg md:text-xl space-y-4 text-right leading-relaxed max-w-3xl mx-auto">
            <li>
              <span className="font-bold text-[#0B3C66]">שחרור סתימות</span>{" "}
              בכיורים, מקלחות, שירותים וקווי ניקוז.
            </li>
            <li>
              <span className="font-bold text-[#0B3C66]">תיקון ניאגרות</span>{" "}
              סמויות ורגילות.
            </li>
            <li>
              <span className="font-bold text-[#0B3C66]">החלפת ברזים</span>{" "}
              וכלים סניטריים.
            </li>
            <li>
              <span className="font-bold text-[#0B3C66]">תיקון דודי שמש</span>{" "}
              ותקלות מים חמים.
            </li>
            <li>
              <span className="font-bold text-[#0B3C66]">
                עבודות אינסטלציה כלליות
              </span>{" "}
              לבית, למשרד ולעסק.
            </li>
          </ul>
        </div>

        {/* AREA */}
        <div className="mb-12 text-center bg-[#E6F7FA] p-8 rounded-xl">
          <h2 className="text-xl md:text-3xl text-[#005B8E] mb-4 font-semibold">
            אזורי שירות
          </h2>

          <p className="text-lg md:text-2xl text-gray-700 leading-relaxed">
            שומרון, ראש העין ופתח תקווה.
          </p>
        </div>

        {/* WHY */}
        <div className="mb-12">
          <h2 className="text-2xl md:text-4xl text-center text-[#00B6C4] mb-6 font-semibold">
            למה לבחור במוטי?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <div className="border border-gray-200 rounded-xl p-5 shadow-sm">
              <h3 className="text-xl font-bold text-[#0B3C66] mb-2">
                הצוות של מוטי
              </h3>
              <p className="text-gray-700 text-lg leading-relaxed">
                הצוות של מוטי מגיע לשטח, בודק את התקלה ומטפל בה בצורה מסודרת
                ומקצועית.
              </p>
            </div>

            <div className="border border-gray-200 rounded-xl p-5 shadow-sm">
              <h3 className="text-xl font-bold text-[#0B3C66] mb-2">
                אמינות לפני הכל
              </h3>
              <p className="text-gray-700 text-lg leading-relaxed">
                אין הפתעות בסוף העבודה. מקבלים הסבר ברור ומחיר לפני שמתחילים.
              </p>
            </div>

            <div className="border border-gray-200 rounded-xl p-5 shadow-sm">
              <h3 className="text-xl font-bold text-[#0B3C66] mb-2">
                זמינות ומהירות
              </h3>
              <p className="text-gray-700 text-lg leading-relaxed">
                כשיש סתימה, נזילה או תקלה במים, צריך מישהו שמבין שזה דחוף.
              </p>
            </div>

            <div className="border border-gray-200 rounded-xl p-5 shadow-sm">
              <h3 className="text-xl font-bold text-[#0B3C66] mb-2">
                אחריות על העבודה
              </h3>
              <p className="text-gray-700 text-lg leading-relaxed">
                כל עבודה מתבצעת בצורה יסודית, נקייה ועם אחריות.
              </p>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mb-8 bg-[#0B3C66] text-white rounded-2xl p-8">
          <h2 className="text-2xl md:text-4xl font-bold mb-5">
            יש תקלה? אל תחכה שהנזק יגדל.
          </h2>

          <p className="text-lg md:text-xl mb-6 leading-relaxed">
            התקשר עכשיו למוטי או שלח הודעה בוואטסאפ עם תיאור קצר של הבעיה.
          </p>

          <div className="flex flex-col md:flex-row gap-3 justify-center items-center">
            <a
              href={`tel:${phone}`}
              className="bg-white hover:bg-gray-100 text-[#0B3C66] text-xl md:text-2xl py-4 px-8 rounded-full shadow-lg font-bold transition"
            >
              התקשר למוטי
            </a>

            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#00B6C4] hover:bg-[#0097a7] text-white text-xl md:text-2xl py-4 px-8 rounded-full shadow-lg font-bold transition"
            >
              שלח הודעה
            </a>
          </div>
        </div>

        <h3 className="mt-8 text-xl md:text-2xl text-[#0B3C66] font-bold text-center">
          מוטי שוקרון — אינסטלטור אמין, מקצועי וזמין. עבודה מכל הלב.
        </h3>
      </div>

      {/* FLOATING WHATSAPP */}
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="שליחת הודעה בוואטסאפ"
        className="fixed bottom-5 left-5 bg-[#00B6C4] hover:bg-[#0097a7] text-white px-5 py-3 rounded-full shadow-xl text-base md:text-lg font-bold transition"
      >
        וואטסאפ
      </a>
    </div>
  );
}
